import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import { NamedLink } from '../../components';
import css from './SectionFinalCTA.module.css';

const SectionFinalCTA = props => {
  const { title, subtitle, buttonText, buttonLink, badges } = props;

  return (
    <section className={css.root}>
      <div className={css.overlay}></div>
      <div className={css.container}>
        <h2 className={css.title}>{title}</h2>
        {subtitle && <p className={css.subtitle}>{subtitle}</p>}
        
        {buttonLink.startsWith('/') ? (
          <NamedLink name="SearchPage" className={css.button}>
            {buttonText}
          </NamedLink>
        ) : (
          <a href={buttonLink} className={css.button}>
            {buttonText}
          </a>
        )}

        {badges && badges.length > 0 && (
          <div className={css.badges}>
            {badges.map((badge, index) => (
              <div key={index} className={css.badge}>
                <svg aria-hidden="true" className={css.badgeIcon} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span className={css.badgeText}>{badge.text}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

SectionFinalCTA.defaultProps = {
  subtitle: null,
  badges: [],
};

SectionFinalCTA.propTypes = {
  title: string.isRequired,
  subtitle: string,
  buttonText: string.isRequired,
  buttonLink: string.isRequired,
  badges: arrayOf(
    shape({
      text: string.isRequired,
    })
  ),
};

export default SectionFinalCTA;